import {Checkbox, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from '@mui/material'
import {useEffect, useState} from 'react'
import {useCompany} from 'src/contexts/CompanyContext'

type CompaniesSelectProps = {
  selectLabel: string
  selectSize: 'small' | 'medium'
  setSelectedCompaniesIds: (ids: number[]) => void
  multiple: boolean
  disabled: boolean
  companiesSelected?: Array<string>
}

function CompaniesSelect({selectLabel, selectSize, setSelectedCompaniesIds, multiple = true, disabled = false, companiesSelected}: CompaniesSelectProps) {
  const {companies} = useCompany()
  const [companyNames, setCompanyNames] = useState<string[]>([])

  const handleChangeDefault = (event: SelectChangeEvent<string[]>) => {
    const {
      target: {value},
    } = event
    setCompanyNames(typeof value === 'string' ? value.split(',') : value)
    setSelectedCompaniesIds(companies.filter((it) => value.includes(it.name)).map((it) => it.id))
  }

  useEffect(() => {
    if (companiesSelected) setCompanyNames(companiesSelected)
  }, [companiesSelected])

  return (
    <FormControl sx={{width: '100%', fontFamily: 'Inter, sans-serif'}}>
      <InputLabel htmlFor='companies' sx={{fontFamily: 'Inter, sans-serif'}}>
        {selectLabel}
      </InputLabel>
      <Select
        multiple={multiple}
        label={selectLabel}
        required
        disabled={disabled}
        size={selectSize || 'small'}
        value={companyNames}
        renderValue={(selected) => selected.join(', ')}
        onChange={handleChangeDefault}
        MenuProps={{
          style: {
            maxHeight: 500,
            fontFamily: 'Inter, sans-serif',
          },
        }}>
        {companies.map((company, index) => (
          <MenuItem key={'role-' + index} value={company.name}>
            {multiple && <Checkbox checked={companyNames.indexOf(company.name) > -1} />}
            {company.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default CompaniesSelect
